import {
  MembershipBenefitType,
  MembershipRecognitionMode,
  MembershipRecognitionScope,
} from "@/types/enums/membership";
import { MembershipDetail } from "@/types/inventory/membership";
import { Page, PageParams } from "@/types/pagination";

import {
  getMembership,
  listMemberships,
  previewRecognitionRestamp,
} from "./membership";

export interface RecognitionRestampPreviewParams {
  benefitType: MembershipBenefitType;
  recognitionMode: MembershipRecognitionMode;
  scope: MembershipRecognitionScope;
  // Benefits the unsaved edit gives a value per use, so a split preview counts their cycles.
  valuedTemplateIds?: string[];
  // Benefits it clears, so their stored value no longer counts.
  unvaluedTemplateIds?: string[];
}

export type MembershipFilters = PageParams & {
  name?: string;
  isArchived?: boolean;
};

export const membershipQueryKeys = {
  all: ["inventory", "memberships"] as const,
  list: (filters?: MembershipFilters) =>
    [...membershipQueryKeys.all, "list", filters] as const,
  detail: (id: string) => [...membershipQueryKeys.all, "detail", id] as const,
  recognitionRestampPreview: (
    id: string,
    params: RecognitionRestampPreviewParams,
  ) =>
    [
      ...membershipQueryKeys.all,
      "recognition-restamp-preview",
      id,
      params,
    ] as const,
};

export const membershipQueryOptions = {
  list: (filters?: MembershipFilters) => ({
    queryKey: membershipQueryKeys.list(filters),
    queryFn: () => listMemberships(filters),
    select: (data: Page<MembershipDetail> | null) => data?.data ?? [],
    staleTime: 1000 * 60 * 5, // 5 minutes
  }),
  detail: (id: string) => ({
    queryKey: membershipQueryKeys.detail(id),
    queryFn: () => getMembership(id),
    staleTime: 1000 * 60 * 5,
  }),
  recognitionRestampPreview: (
    id: string,
    params: RecognitionRestampPreviewParams,
  ) => ({
    queryKey: membershipQueryKeys.recognitionRestampPreview(id, params),
    queryFn: () => previewRecognitionRestamp(id, params),
  }),
};
